import { Icon } from '@/components/ui';
import { cn } from '@/utils/cn';

interface LoadingSpinnerProps {
  message?: string;
  fullPage?: boolean;
  size?: number;
}

export function LoadingSpinner({ message = 'Loading...', fullPage = false, size = 24 }: LoadingSpinnerProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3',
        fullPage ? 'min-h-screen' : 'flex-1 py-8',
      )}
      role="status"
      aria-live="polite"
    >
      <Icon name="spinner" size={size} style={{ color: 'var(--brand)' }} />
      {message && (
        <div style={{ fontSize: 12.5, color: 'var(--text-3)' }}>{message}</div>
      )}
    </div>
  );
}
